import ISubOrder from "../Models/Courier/ISubOrder";
import IOrder from "../Models/IOrder";
import {AnyAction} from "redux";
import {Dimensions, Modal, Platform, TouchableOpacity, View} from "react-native";
import React, {Component} from "react";
import DateTimePicker from '@react-native-community/datetimepicker';
import AppText from "./AppText";
import AppButton from "./AppButton";

interface IProps {
   show:boolean;
   mode:'date' | 'time';
   onChange:Function;
    closeCallBack:Function;
}
interface IState {
    selectedDate:Date;
}
const width=Dimensions.get('window').width;
export  default class DateTimePickerModal extends Component< IProps > {
    state:IState={
        selectedDate:new Date()
    }
    render(){
        if(Platform.OS=='android'){
            return (
            this.props.show&&<DateTimePicker
                    testID="dateTimePicker"
                    value={this.state.selectedDate}

                    is24Hour={true}

                    display="spinner"
                    onChange={(event, selectedDate) =>{
                        //this.props.closeCallBack()
                        this.props.onChange(selectedDate);
                        this.setState({selectedDate:selectedDate});

                    }}
                    mode={this.props.mode}
                />
            )
        }
        return(

            <Modal
                animationType="fade"
                transparent={true }
                visible={ this.props.show ? true : false}

                onRequestClose={() => {

                }}
            >
                <View style={{backgroundColor:'rgba(0,0,0,0.5)',width:'100%',height:'100%',justifyContent:'center',alignItems:'center'}}>
                    <View style={{width:'90%',height:300,backgroundColor:'white'}}>
                        <TouchableOpacity onPress={()=>this.props.closeCallBack()}>
                            <AppText style={{fontSize:22,marginLeft:5,marginRight:5}}>X</AppText>
                        </TouchableOpacity>

                        <DateTimePicker
                            testID="dateTimePicker"
                            value={this.state.selectedDate}

                            is24Hour={true}

                            display="spinner"
                            onChange={(event, selectedDate) =>{

                                this.setState({selectedDate:selectedDate})
                            }}
                            mode={this.props.mode}
                        />
                        <View style={{width:'100%',justifyContent:'center',alignItems:'center'}}>
                            <AppButton text={'בחר'} width={200} onPress={()=> {
                                this.props.onChange(this.state.selectedDate);
                                this.props.closeCallBack()
                            }}/>
                        </View>

                    </View>
                </View>
            </Modal>
        )
    }
}
